<template>
    <div id="active71">

        <div class="box">
            <div class="option" @click="active=100;show=true">
                <p class="title">免费看全年</p>
                <div class="info">
                    <h3><span>¥</span>399</h3>
                    <p class="a">全站书籍免费看全年</p>
                    <p class="b">超值畅读</p>
                </div>
            </div>
            <div class="option" @click="active=102;show=true">
                <p class="title">免费看两年</p>
                <div class="info">
                    <h3><span>¥</span>699</h3>
                    <p class="a">全站书籍免费看两年</p>
                    <p class="b">立省百元</p>
                </div>
            </div>
        </div>

        <div class="type" v-if="show" @click="show=false">
            <ul>
                <li class="wechat" :class="{active:type == 6}" @click="setType(6)">
                    <img src="http://static.yuread.cn/quick/wechat1.png" alt=""> 微信充值
                </li>
                <li class="zfb" :class="{active:type == 7}" @click="setType(7)">
                    <img src="http://static.yuread.cn/quick/zfb1.png" alt=""> 支付宝
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Active68",
        data(){
            return {
                type : 6,
                show : false,
                active : 100,

            }
        },
        methods : {
            setType(type){
                this.type = type;
                system.postMessage(JSON.stringify({
                    active : this.active,
                    type : this.type
                }))
            }
        }
    }
</script>

<style lang="less">
    #active71{min-height:100%;background-color:#d92407;overflow: auto;background-image: url("http://static.yuread.cn/quick/71-1.png");background-repeat: no-repeat;background-size: 100% auto;
        .a{width: 100%;}
        .box{display: flex;width: 698px;height:540px;padding:150px 40px 0;justify-content: space-between;margin:960px auto 30px;background-image: url("http://static.yuread.cn/quick/71-2.png");background-size: 100%;background-repeat: no-repeat;
            .option{width: 300px;height:342px;background-image: url("http://static.yuread.cn/quick/71-3.png");background-size:100% 100%;background-repeat:no-repeat;
                .title{text-align: center;font-size: 24px;color: #B2000D;line-height: 46px;}
                .info{text-align: center;
                    h3{font-size: 72px;color: #FD1B1F;
                        span{font-size: 40px;}
                    }
                    .a{font-size: 20px;color: #B48037;margin: 10px 0;}
                    .b{font-size: 24px;color: #D55111;margin: 10px 0;}
                }
            }
        }
        .box1{width: 668px;height: 556px;margin: 30px auto 80px;
            img{width: 100%;height: 100%;}
        }
        .tip{font-size: 24px;color: #fff;text-align: center;margin-top: 20px;}
        .type{
            background-color: rgba(0,0,0,.3);position: fixed;top:0;left:0;right:0;bottom:0;
            ul{ position:absolute;bottom:0;width: 100%;background-color: #fff;display: flex;justify-content: space-between;padding: 102px 40px 68px;border-radius: 58px 58px 0 0;
                li{width: 308px;height:86px;text-align: center;border-radius: 43px;color: #fff;font-size: 32px;line-height: 86px;}
                .wechat{background-color: #32BE1B;}
                .zfb{background-color: #1296db;}
                img{width: 34px;height:34px;position: relative;top:5px;}
            }
        }
    }
</style>
